// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const FaceEyesClosedOutline = (props: SVGProps<SVGSVGElement>) => (
	<svg width="1em" height="1em" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M83.529 47.999c0 19.592-15.938 35.53-35.529 35.53s-35.531-15.938-35.531-35.53c0-19.591 15.94-35.529 35.531-35.529s35.529 15.938 35.529 35.529Zm3.971 0C87.5 26.219 69.78 8.5 48 8.5 26.219 8.5 8.5 26.219 8.5 47.999s17.719 39.5 39.5 39.5c21.78 0 39.5-17.72 39.5-39.5Zm-19.405-8.934c0-3.315-2.983-6.013-6.65-6.013-3.309 0-6.074 2.141-6.574 5.092a1.929 1.929 0 1 0 3.802.646c.179-1.055 1.396-1.881 2.772-1.881 1.515 0 2.794.987 2.794 2.156a1.928 1.928 0 1 0 3.856 0Zm-36.335 0c0-1.169 1.28-2.156 2.794-2.156 1.375 0 2.592.826 2.772 1.881a1.932 1.932 0 0 0 2.224 1.579 1.93 1.93 0 0 0 1.578-2.225c-.5-2.951-3.266-5.092-6.574-5.092-3.667 0-6.65 2.698-6.65 6.013a1.928 1.928 0 1 0 3.856 0Zm15.836 23.882c-.326 0-.652-.008-.979-.024-4.801-.233-9.059-2.213-11.681-5.432a1.93 1.93 0 0 1 2.99-2.436c1.932 2.373 5.168 3.836 8.878 4.016 4.401.217 8.692-1.34 11.479-4.155a1.93 1.93 0 0 1 2.741 2.714c-3.333 3.366-8.295 5.317-13.428 5.317Z"
			fill="#fff"
		/>
	</svg>
);
export default FaceEyesClosedOutline;
